import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  disable() {
    this.locked = true
    this.buttons.forEach((button) => {
      button.setAttribute("aria-busy", "true")
      button.classList.add("pointer-events-none")
      window.setTimeout(() => {
        if (this.locked) button.disabled = true
      }, 0)
    })
  }

  enable() {
    this.locked = false
    this.buttons.forEach((button) => {
      button.removeAttribute("aria-busy")
      button.classList.remove("pointer-events-none")
      button.disabled = false
    })
  }

  get buttons() {
    if (this.hasButtonTarget) return this.buttonTargets

    return Array.from(this.element.querySelectorAll('button[type="submit"], input[type="submit"]'))
  }
}
